import * as React from 'react'

export function RoomsRecreation(props) {
  return (
    <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M25 22a3 3 0 110 6 3 3 0 010-6zm1.348-1.792A4.93 4.93 0 0025 20c-2.756 0-5 2.243-5 5-2.366.52-5.127.072-7.326-1.046a1.49 1.49 0 00-1.73.275l-3.492 3.478a1.001 1.001 0 01-1.415 0l-1.744-1.738a.998.998 0 010-1.412l3.492-3.481c.447-.447.578-1.134.287-1.695a10.513 10.513 0 013.292-13.4c3.728-2.672 8.608-2.636 12.305.08 4.68 3.438 5.556 9.64 2.678 14.147z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}
